/* eslint-disable */
import config from '../../../config'
import { months2026, weekdayHeaders } from '../../Calendar/calendarData2026'
import styles from './index.module.scss'
import {
  Article,
  Post,
  RightArrow,
  CalendarIcon,
  LibraryIcon,
  Journal,
  Calculator2,
  Decrase,
  Dot,
  Increase,
} from '../../../icons'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import CurrencyApi from '../../../api/currency'
import NewsApi from '../../../api/news'
import { Link } from 'react-router-dom'
import React, { useState, useContext, useEffect } from 'react'
import {
  EventCard,
  MagazineCard,
  ServiceCard,
} from '../../../components/core/cards'
import './style.css'
import { PageContext } from '../../../context/PageContextProvider'
import text from './text.json'
import translate from '../../../utils/translate.json'
import Loading from '../../../components/pages/loading'
import img from '../../../assets/images/news.jpg'

const Events = () => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [current, setCurrent] = useState(0)
  const [data, setData] = useState(null)
  const [events, setEvents] = useState(null)
  const [telim, setTelim] = useState(null)
  const [curr, setCurr] = useState(null)

  const curDate = new Date()
  const curMonthIdx = curDate.getMonth()
  const prevMonthIdx = (curMonthIdx - 1 + 12) % 12
  const homeCalendarMonths = [months2026[prevMonthIdx], months2026[curMonthIdx]]

  useEffect(() => {
    (async () => {
      try {
        const datum = await CurrencyApi.getAllCurrencies()
        const majorCodes = ['USD', 'EUR', 'RUB', 'TRY', 'GBP']
        const allCurr = datum.data || []
        let filtered = allCurr.filter((c) => majorCodes.includes(c.code))
        if (filtered.length > 0) {
          filtered.sort((a, b) => majorCodes.indexOf(a.code) - majorCodes.indexOf(b.code))
          await setCurr(filtered)
        } else {
          const fallback = await CurrencyApi.getAll()
          await setCurr(fallback.data)
        }
      } catch (e) {
        const fallback = await CurrencyApi.getAll()
        await setCurr(fallback.data)
      }
      try {
        const { data } = await NewsApi.getHome()
        const { data: telims } = await NewsApi.getHomeTelim()
        const { data: eventsData } = await NewsApi.getHomeEvents()
        await setData(data)
        await setTelim(telims)
        await setEvents(eventsData)
      } catch (err) {
        console.error('Failed to load events data:', err)
      }
      await setLoad(true)
    })()
  }, [])
  const tabs = [
    {
      icon: Article,
      tab: {
        AZ: 'Xəbərlər',
        ENG: 'News',
        RU: 'Новости',
        TR: 'Haberler',
      },
      link: '/useful/news',
      class: 'not-last',
    },
    {
      icon: Post,
      tab: {
        AZ: 'Tədbirlər',
        ENG: 'Events',
        RU: 'Мероприятия',
        TR: 'Etkinlikler',
      },
      link: '/useful/events',
      class: 'not-last',
    },
    {
      icon: Article,
      tab: {
        AZ: 'Təlimlər',
        ENG: 'Trainings',
        RU: 'Тренинги',
        TR: 'Eğitimler',
      },
      link: '/useful/training',
      class: 'not-last',
    },
    {
      icon: CalendarIcon,
      tab: {
        AZ: 'Təqvim',
        ENG: 'Calendar',
        RU: 'Календарь',
        TR: 'Takvim',
      },
      link: '/useful/calendar',
      class: 'last',
    },
    {
      icon: Calculator2,
      tab: {
        AZ: 'Kalkulyator',
        ENG: 'Calculator',
        RU: 'Калькулятор',
        TR: 'Hesaplayıcı',
      },
      link: '/useful/calculator',
      class: 'last',
    },
    {
      icon: Article,
      tab: {
        AZ: 'Valyuta',
        ENG: 'Currency',
        RU: 'Валюта',
        TR: 'Döviz',
      },
      link: '/useful/currency',
      class: 'not-last',
    },
  ]
  return load ? (
    <section className={`${styles.container}`}>
      <Tabs
        className="events-tabs"
        selectedIndex={current}
        onSelect={(index) => setCurrent(index)}
        defaultIndex={0}
      >
        <div>
          <TabList>
            {tabs.map((item, i) => (
              <Tab
                key={i}
                onClick={() => {
                  setCurrent(i)
                }}
              >
                {<item.icon className={item.class} />}
                {item.tab?.[language] || item.tab?.TR || item.tab?.AZ || ''}
              </Tab>
            ))}
          </TabList>
          <Link to={tabs[current] ? tabs[current].link : '/useful/news'}>
            {text.link[language] || text.link.TR || text.link.AZ} <RightArrow />
          </Link>
        </div>

        <TabPanel>
          {data && Array.isArray(data) && data.map((item, i) => (
            <EventCard
              key={i}
              img={
                item.photoLocation
                  ? (item.photoLocation.startsWith('http') ? item.photoLocation : `${config.API_URL}${item.photoLocation}`)
                  : img
              }
              title={item.title?.[language] || ''}
              date={new Date(item.date).toLocaleDateString()}
              event={item.newsType}
              label={item.isActive}
              bool={item._id === '637de3a08d5a08da16962c0c'}
              to={`/news/${item._id}`}
            />
          ))}
        </TabPanel>
        <TabPanel>
          {events && Array.isArray(events) && events.map((item, i) => (
            <EventCard
              key={i}
              img={
                item.photoLocation
                  ? (item.photoLocation.startsWith('http') ? item.photoLocation : `${config.API_URL}${item.photoLocation}`)
                  : img
              }
              title={item.title?.[language] || ''}
              date={new Date(item.date).toLocaleDateString()}
              event={item.newsType || 'event'}
              label={item.isActive}
              to={`/news/${item._id}`}
            />
          ))}
        </TabPanel>
        <TabPanel>
          {telim && Array.isArray(telim) && telim.map((item, i) => (
            <EventCard
              key={i}
              img={
                item.photoLocation
                  ? (item.photoLocation.startsWith('http') ? item.photoLocation : `${config.API_URL}${item.photoLocation}`)
                  : img
              }
              title={item.title?.[language] || ''}
              date={new Date(item.date).toLocaleDateString()}
              event={item.newsType || 'telim'}
              label={item.isActive}
              to={`/news/${item._id}`}
            />
          ))}
        </TabPanel>

        {/* <TabPanel>
          {data2.map((item) => (
            <MagazineCard
              to={'#'}
              img={item.image}
              title={item.title}
              label={item.label}
            />
          ))}
        </TabPanel> */}
        <TabPanel className="calendar">
          <div className={styles.miniCalendarGrid}>
            {homeCalendarMonths.map((m) => {
              const emptyCells = Array.from({ length: m.startOffset })
              const dayCells = Array.from({ length: m.days }, (_, idx) => idx + 1)
              return (
                <div key={m.index} className={`${styles.miniCalendarCard} bpg-card-neon`}>
                  <div className={styles.miniMonthHeader}>
                    <h4>{m.name?.[language] || m.name?.TR || m.name?.AZ} 2026</h4>
                    <span>{m.quarter}{language === 'TR' ? '. Çeyrek' : language === 'RU' ? ' квартал' : language === 'ENG' ? ' Quarter' : '-ci Rüb'}</span>
                  </div>
                  <div className={styles.miniStats}>
                    <span>{language === 'TR' ? 'İş:' : language === 'RU' ? 'Рабочие:' : language === 'ENG' ? 'Work:' : 'İş:'} <strong>{m.workDays} {language === 'RU' ? 'дней' : language === 'ENG' ? 'days' : 'gün'}</strong></span>
                    <span>{language === 'TR' ? 'Tatil:' : language === 'RU' ? 'Выходные:' : language === 'ENG' ? 'Non-work:' : 'Qeyri-iş:'} <strong>{m.nonWorkDays} {language === 'RU' ? 'дней' : language === 'ENG' ? 'days' : 'gün'}</strong></span>
                    <span><strong>{m.workHours} {language === 'RU' ? 'часов' : language === 'ENG' ? 'hours' : 'saat'}</strong></span>
                  </div>
                  <div className={styles.miniWeekdays}>
                    {(weekdayHeaders[language] || weekdayHeaders.TR || weekdayHeaders.AZ).map((wd, i) => (
                      <div key={i}>{wd}</div>
                    ))}
                  </div>
                  <div className={styles.miniDaysGrid}>
                    {emptyCells.map((_, i) => (
                      <div key={`empty-${i}`} className={`${styles.miniDayCell} ${styles.empty}`} />
                    ))}
                    {dayCells.map((d) => {
                      const dayOfWeek = (m.startOffset + d - 1) % 7
                      const isWeekend = dayOfWeek === 5 || dayOfWeek === 6
                      const special = m.specialDays[d]
                      let cellClass = styles.miniDayCell
                      if (special) {
                        if (special.type === 'holiday') cellClass += ` ${styles.holiday}`
                        else if (special.type === 'mourning') cellClass += ` ${styles.mourning}`
                        else if (special.type === 'shortened') cellClass += ` ${styles.shortened}`
                      } else if (isWeekend) {
                        cellClass += ` ${styles.weekend}`
                      }
                      const tooltip = special
                        ? `${d} ${m.name?.[language] || m.name?.AZ}: ${special.title?.[language] || special.title?.TR || special.title?.AZ}`
                        : isWeekend
                        ? `${d} ${m.name?.[language] || m.name?.AZ}: ${language === 'TR' ? 'Hafta sonu' : language === 'RU' ? 'Выходной' : language === 'ENG' ? 'Weekend' : 'Həftəsonu'}`
                        : `${d} ${m.name?.[language] || m.name?.AZ}`
                      return (
                        <div key={d} className={cellClass} title={tooltip}>
                          {d}
                        </div>
                      )
                    })}
                  </div>
                  <Link to="/useful/calendar" className={styles.miniCardFooter}>
                    <span>{language === 'AZ' ? 'Tam İstehsalat Təqvimi 2026' : language === 'TR' ? 'Tam Çalışma Takvimi 2026' : language === 'RU' ? 'Полный календарь 2026' : 'Full 2026 Calendar'}</span>
                    <RightArrow />
                  </Link>
                </div>
              )
            })}
          </div>
        </TabPanel>
        {/* <TabPanel>
          {data3.map((item) => (
            <MagazineCard
              img={item.image}
              title={item.title}
              label={item.label}
              to={`/book/${item.id}`}
            />
          ))}
        </TabPanel> */}
        <TabPanel>
          <ServiceCard
            name={
              language === 'TR'
                ? 'Maaş Kesintileri'
                : translate.deductions?.[language] || ''
            }
            detail={false}
            link={'/useful/calculator/1'}
          />
          <ServiceCard
            name={
              language === 'TR'
                ? 'İzin Ücreti'
                : translate.severance?.[language] || ''
            }
            detail={false}
            link={'/useful/calculator/2'}
          />
          <ServiceCard
            name={
              language === 'TR'
                ? 'Doğum ve Gebelik Ödeneği'
                : translate.pregnancy?.[language] || ''
            }
            detail={false}
            link={'/useful/calculator/3'}
          />
          <ServiceCard
            name={
              language === 'TR'
                ? 'Son Hakediş ve Tazminat'
                : translate.termination_settlement?.[language] || 'Əmək müqaviləsinə xitam və son haqq-hesab'
            }
            detail={false}
            link={'/useful/calculator/4'}
          />
        </TabPanel>
        <TabPanel>
          <div className={`${styles.currencyCardWrap} bpg-card-neon`}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>{translate.currency?.[language] || ''}</th>
                  <th>{language === 'AZ' ? 'Rəsmi Məzənnə' : language === 'TR' ? 'Resmi Kur' : language === 'ENG' ? 'Official Rate' : 'Официальный курс'}</th>
                  <th>
                    <Increase /> <Dot /> <Decrase />
                  </th>
                </tr>
              </thead>
              <tbody>
                {curr && Array.isArray(curr) && curr.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <strong>{(item.code || '').toUpperCase()}</strong>
                      <span style={{ display: 'block', fontSize: '12px', color: '#64748b' }}>
                        {item.currency?.[language] || item.currency?.AZ || item.name || item.code}
                      </span>
                    </td>
                    <td style={{ fontWeight: 600 }}>{Number(item.rate) ? Number(item.rate).toFixed(4) : item.rate} AZN</td>
                    <td>
                      {item.sign === 'up' ? (
                        <Increase />
                      ) : item.sign === 'down' ? (
                        <Decrase />
                      ) : (
                        <Dot />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </TabPanel>
      </Tabs>
    </section>
  ) : (
    <Loading />
  )
}

export default Events
